var _defs, _g, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShortSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SHORT_SIDE",
    "data-name": "SHORT SIDE",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.5,
    height: 22.7,
    viewBox: "0 0 36.5 22.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #SHORT_SIDE .cls-1 {\n        fill: #f5f5f5;\n      }\n\n      #SHORT_SIDE .cls-2 {\n        fill: none;\n        stroke: #c5d75d;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1048",
    "data-name": "Gruppe 1048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_418",
    "data-name": "Pfad 418",
    className: "cls-1",
    d: "M0,0V19H13.9a4.1,4.1,0,0,0,4,3.7,4.026,4.026,0,0,0,4-3.7H36V0ZM17.9,21.7a3.031,3.031,0,0,1-3-2.7v-.3A1.7,1.7,0,0,1,15,18a2.978,2.978,0,0,1,5.8,0c0,.2.1.4.1.7V19A3.108,3.108,0,0,1,17.9,21.7ZM35,18H21.8A3.955,3.955,0,0,0,14,18H1V1H35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_419",
    "data-name": "Pfad 419",
    className: "cls-1",
    d: "M17.9,16.7A2.1,2.1,0,0,0,16,18a1.483,1.483,0,0,0-.1.7V19a2.133,2.133,0,0,0,2,1.7,2.034,2.034,0,0,0,2-1.7v-.3a1.7,1.7,0,0,0-.1-.7A1.955,1.955,0,0,0,17.9,16.7Z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Linie_1387",
    "data-name": "Linie 1387",
    className: "cls-2",
    y2: 19,
    transform: "translate(35)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortSide);
export default __webpack_public_path__ + "static/media/short-side.db6a720bfb7f528ed3b58eeca0c29b37.svg";
export { ForwardRef as ReactComponent };